import { IHttpService, ILocationService, IScope } from "angular";
import { OAuthUser } from "./account.model";

angular.module('logbook')
	.controller('oauth-signup', ['$scope', '$http', '$location',
		function($scope: IScope, $http: IHttpService, $location: ILocationService) {
			$http.get<OAuthUser>('api/oauth2User').then(result => {
				$scope.oauthUser = result.data;
			});

			$scope.doCreateNew = () => {
				$http.post('api/logBookUsers', {
					firstName: $scope.oauthUser.details.given_name,
					lastName: $scope.oauthUser.details.family_name,
					newUserData: {
						'dummy1': 'logbook'
					}
				})
				.then(() => {
					$location.url('/signup')
						.search('email', $scope.oauthUser.details.email)
						.search('submitted', "Y");
				});
			};

			$scope.doLinkExisting = () => {
				$scope.linkExisting = true;
			};
		}]
	);